import LoginForm from "../../components/Forms/LoginForm";

const Login = () => {
  return <LoginForm />;
};

export default Login;
